import API from '../apiCreate'

const unwrap = async (request) => {
  const response = await request
  if (response?.data?.status !== 'success') {
    throw new Error(String(response?.data?.error || 'Не удалось выполнить операцию'))
  }
  return response.data.data
}

export const studentBillingApi = {
  list: (params) => unwrap(API.get('student-billing/index', { params })),
  students: (search = '') => unwrap(API.get('student-billing/students', { params: { search } })),
  products: (user_id) => unwrap(API.get('student-billing/products', { params: { user_id } })),
  companies: () => unwrap(API.get('student-billing/companies')),
  saveCompany: (data) => unwrap(API.post('student-billing/save-company', data)),
  create: (data) => unwrap(API.post('student-billing/create', data)),
  preview: (id, paid) => unwrap(API.get('student-billing/payment-preview', { params: { id, paid: paid ? 1 : 0 } })),
  setPaid: (id, paid, skip_effect) => unwrap(API.post('student-billing/set-paid', { id, paid, skip_effect })),
  remove: (id) => unwrap(API.post('student-billing/delete', { id })),
  createAct: (id) => unwrap(API.post('student-billing/create-act', { id })),
  download: (id, type) => API.get('student-billing/download', { params: { id, type }, responseType: 'blob' }),
}
